import { styled } from '@ori-ui/mui';
export var ArrowRoot = styled('div')(function (_ref) {
  var theme = _ref.theme,
    disabled = _ref.disabled;
  return {
    display: 'grid',
    flex: 'none',
    placeItems: 'center',
    position: 'relative',
    width: 48,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(22),
    WebkitTapHighlightColor: 'transparent',
    opacity: disabled ? 0 : 1
  };
});
//# sourceMappingURL=arrow.js.map